import React from 'react';
import { capitalizeWord, keyToString, stringToKey } from '../../util/data';
import { H3 } from '../../components';
import css from './ListingDetails.module.css';
import { FormattedMessage } from 'react-intl';
import IconCollection from '../../components/IconCollection/IconCollection';
import Collapsible from 'react-collapsible';

const prepareTravelStyleSpecialties = publicData => {
  const { services = [] } = publicData || {};

  return services
    .map(service =>
      publicData?.[stringToKey(service)]?.length
        ? { label: service, data: publicData[stringToKey(service)] }
        : null
    )
    .filter(Boolean);
};

const ListingDetails = ({ publicData }) => {
  const { languages = [], countryOfResidence, eta } = publicData || {};
  const languagesSpoken = languages
    .map(({ parent, child }) => `${parent} (${capitalizeWord(child)})`);

  const travelStyleSpecialties = prepareTravelStyleSpecialties(publicData);

  const primaryDetails = [
    {
      label: <FormattedMessage id="ListingDetails.languageSpoken" />,
      value: languagesSpoken,
    },
    {
      label: <FormattedMessage id="ListingDetails.estimatedTime" />,
      value: eta,
    },
    {
      label: <FormattedMessage id="ListingDetails.located" />,
      value: countryOfResidence,
    },
  ].filter(elm => !!elm.value);

  const destinations  = publicData?.destinations
  const subDestinations = publicData?.subDestinations || "";

  return (
    <div className={css.container}>
      <div>
        <H3 className={css.titleText}>Details</H3>
        <div className={css.listItems}>
          {primaryDetails.map(({ label, value }, index) => (
            <div key={index} className={css.listItem}>
              {label}
              <span className={css.boldText}>
                {Array.isArray(value) ? value.map((v, i) => (
                  <div key={i}>
                    {v}{i < value.length - 1 && ','}
                  </div>
                )) : value}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div>
        <H3 className={css.titleText}>Destination Specialties</H3>
        <div className={css.listItemsDestination}>
            {destinations && destinations.map(d => (
              <div key={d} className={css.listItemDestination}>
                <IconCollection icon="checkIcon" />
                {keyToString(d)}
              </div>
            ))}
        </div>
        <div className={css.listItemsDestination}>
            {subDestinations && subDestinations.map(d => (
              <div key={d} className={css.listItemDestination}>
                <IconCollection icon="checkIcon" />
                {keyToString(d.full_address)}
              </div>
            ))}
        </div>
      </div>

      {!!travelStyleSpecialties.length && (
        <div>
          <div>
            <H3 className={css.titleText}>Travel Style Specialties</H3>
            {/* <p className={css.subTitle}>Explainer text for what this is</p> */}
          </div>
          <div className={css.faqContent}>
            {travelStyleSpecialties.map(({ label, data }) => (
              <div className={css.faqText} key={label}>
                <Collapsible trigger={label}>
                  <div className={css.collapsibleContent}>{data}</div>
                </Collapsible>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ListingDetails;
